import { Card, Form, Radio } from "antd";
import React, { useEffect } from "react";
import { isYounger } from "../../common";
import { ToothSample } from "../../models";
interface PropsType {
  editRecord: ToothSample;
  age: number;
}
export const CItem: React.FC<PropsType> = ({ editRecord, age }) => {
  const [form] = Form.useForm();
  useEffect(() => {
    if (editRecord.key !== -1) {
      form.setFieldsValue({ ...editRecord });
    } else {
      form.setFieldsValue({ c1: "否", c2: "否", c3: "否", c4: "否", c5: "否" });
    }
  }, [editRecord, form, age]);
  const onItemChange = (e: any) => {
    //editRecord.c1 = form.getFieldValue("c1");
    editRecord.c2 = form.getFieldValue("c2");
    editRecord.c3 = form.getFieldValue("c3");
    editRecord.c4 = form.getFieldValue("c4");
    if (!isYounger(age)) {
      editRecord.c5 = form.getFieldValue("c5");
    }
  };
  return (
    <Card title="临床检查" style={{ background: "#ececec", margin: "10px" }}>
      <Form
        layout="horizontal"
        labelCol={{ span: 16 }}
        wrapperCol={{ span: 8 }}
        form={form}
      >
        {isYounger(age) ? (
          <>
            <Form.Item name="c2" label="dmft>=1(dmft为龋失补牙数)">
              <Radio.Group onChange={onItemChange}>
                <Radio value={"是"}>是</Radio>
                <Radio value={"否"}>否</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item name="c3" label="牙齿上有白垩斑或釉质脱矿">
              <Radio.Group onChange={onItemChange}>
                <Radio value={"是"}>是</Radio>
                <Radio value={"否"}>否</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item name="c4" label="牙齿可见菌斑">
              <Radio.Group onChange={onItemChange}>
                <Radio value={"是"}>是</Radio>
                <Radio value={"否"}>否</Radio>
              </Radio.Group>
            </Form.Item>
          </>
        ) : (
          <>
            <Form.Item name="c2" label="dmft>=1(dmft为龋失补牙数)">
              <Radio.Group onChange={onItemChange}>
                <Radio value={"是"}>是</Radio>
                <Radio value={"否"}>否</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item name="c3" label="活动性白垩斑或釉质缺损">
              <Radio.Group onChange={onItemChange}>
                <Radio value={"是"}>是</Radio>
                <Radio value={"否"}>否</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item name="c4" label="口内有不良修复体">
              <Radio.Group onChange={onItemChange}>
                <Radio value={"是"}>是</Radio>
                <Radio value={"否"}>否</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item name="c5" label="佩戴义齿或矫正器">
              <Radio.Group onChange={onItemChange}>
                <Radio value={"是"}>是</Radio>
                <Radio value={"否"}>否</Radio>
              </Radio.Group>
            </Form.Item>
          </>
        )}
      </Form>
    </Card>
  );
};
